import Swiper, { Navigation, A11y } from 'swiper';

export default () => {
  // awards slider
  const awardsSwiper = new Swiper('.awards-wrap-sidebar', {
    modules: [Navigation, A11y],
    navigation: {
      nextEl: '.awards-wrap-sidebar .swiper-button-next',
      prevEl: '.awards-wrap-sidebar .swiper-button-prev',
    },
    a11y: true,
    keyboardControl: true,
    grabCursor: true,
    autoHeight: true,
  });
};